import React from 'react';

export const CuratedHeroContext = React.createContext({});

export const CuratedHeroProvider = CuratedHeroContext.Provider;
